import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function initAnimations(debug = false) {
    document.querySelectorAll('[data-animation]').forEach(el => startAnimation(el, debug));
}

function startAnimation(element, debug = false) {
    const {animation, animationDebug} = element.dataset ?? {};
    debug = Boolean(animationDebug) ?? debug;

    if (!animation) return;

    switch (animation) {
        case 'slide-left':
            slideLeft(element, debug);
            break;
        case 'path':
            path(element, debug);
            break;
        default:
            console.warn(`Animation ${animation} not found`);
    }
}

function slideLeft(element, debug = false) {
    gsap.from(element, {
        scrollTrigger: {
            trigger: element,
            start: 'top 80%',
            end: 'bottom 80%',
            scrub: true,
            markers: debug,
        },
        x: 100,
        opacity: 0,
    });
}

function path(element, debug = false) {
    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: element,
            start: 'top center',
            scrub: true,
            markers: debug,
        },
    });
    tl.fromTo(element,
        {
            clipPath: 'inset(0px 0px 100% 0px)',
        },
        {
            clipPath: 'inset(0px 0px 0% 0px)',
            duration: 2,
        });
}
